import { render, staticRenderFns } from "./UnsubscribeModal.vue?vue&type=template&id=e07e8f18&scoped=true&"
import script from "./UnsubscribeModal.vue?vue&type=script&lang=js&"
export * from "./UnsubscribeModal.vue?vue&type=script&lang=js&"
import style0 from "./UnsubscribeModal.vue?vue&type=style&index=0&id=e07e8f18&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e07e8f18",
  null
  
)

component.options.__file = "UnsubscribeModal.vue"
export default component.exports